export default {
  integrations: {
    Drift: false,
    Marketo: false,
    'Marketo V2': false
  }
};
